import { Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, Box, Snackbar, Alert, TextField, Switch, FormControlLabel } from "@mui/material";
import { Stack } from "@mui/system";
import * as React from "react";
import FileBrowser from "./FileBrowser";
import * as ATCAConstants from '../util/ATCAConstants';

import { get } from 'aws-amplify/api';

export default function SaveScheduleDialog(
  props: {
    open: boolean,
    rootPath: string,
    handleSave: (fullfilename: string) => void,
    handleCancel: () => void,
  }
) {
  const [openSnack, setOpenSnack] = React.useState(false);
  const [newName, setNewName] = React.useState<string>('');
  const [files, setFiles] = React.useState<string[]>([]);
  const [replace, setReplace] = React.useState<boolean>(true);
  const [scheduleNameHelper, setScheduleNameHelper] = React.useState<string>('');
  
  React.useEffect(() => {
    if (props.open) {
      setReplace(false);

      // get files from the backend
      const getOperation = get(
        {
          apiName: 'cabb',
          path: '/list_files',
          options: {
            queryParams: {
              project: props.rootPath + '/'
            }
          }
        }
      );

      getOperation.response
        .then(response => response.body.json())
        .then((response: any) => {
          setFiles(response);
          setNewName('');
        })
        .catch((err: Error) => {
          setOpenSnack(true);
        });
    }
  }, [props.open, props.rootPath]);


  React.useEffect(() => {
    if (!newName) {
      setScheduleNameHelper('Enter file name');
      return;
    }
    if (newName.length > ATCAConstants.MAX_NAME_LENGTH) {
      setScheduleNameHelper(`File name has to be less than ${ATCAConstants.MAX_NAME_LENGTH} characters`);
      return;
    }

    if (!newName.endsWith('.sch')) {
      setScheduleNameHelper('Schedule file has to end with .sch');
      return;
    }
    setScheduleNameHelper('');
  }, [newName]);

  const handleCancel = () => {
    props.handleCancel();
  }

  const handleCreate = () => {
    if (newName) {
      props.handleSave(newName);
    }
  }

  const setSelectedItem = (selectedItem: any) => {
    setNewName(selectedItem['name']);
  }

  const doesFileExist = () => {
    const matchFiles = files.filter(
      (f: any) => {return newName === f['name']}
    );

    return (matchFiles.length > 0);
  }

  const isDisableSave = () => {
    if (scheduleNameHelper)
      return true;

    if (doesFileExist())
      return !replace;

    return false;
  }

  return (
    <Dialog open={props.open} PaperProps={{ sx: {height: '70%'} }}
      aria-labelledby="save-schedule-dialog-title"
      onClose={handleCancel}
      maxWidth="md" fullWidth>
      <DialogTitle id="save-schedule-dialog-title">
        Save Schedule
      </DialogTitle>

      <DialogContent>
        <Stack spacing={0} height={'100%'}>
        <Stack direction={'row'} justifyContent={'space-between'}
          alignItems={'center'} paddingTop={'10px'}>
          <TextField sx={{width: '80%', height: '100px'}}
            id="new-project-name" variant="outlined"
            error = {Boolean(scheduleNameHelper)}
            helperText={scheduleNameHelper}
            label="Schedule File Name"
            value={newName || ''} onChange={e => setNewName(e.target.value)} />
          {
            doesFileExist() 
            &&
            <FormControlLabel
              control={
                <Switch
                  checked={replace}
                  onChange={e => setReplace(e.target.checked)}
                />
              }
              label="Replace"
            />
          }
        </Stack>
        <Box sx={{flexGrow: 4}} >
          <FileBrowser
            paths={files||[]}
            open={props.open}
            setSelectedItem={setSelectedItem}
          />
        </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus
          disabled={isDisableSave()}
          onClick={handleCreate}>
          Save
        </Button>
        <Button onClick={handleCancel}>
          Cancel
        </Button>
      </DialogActions>

      <Snackbar
        role = "alert"
        aria-label = {"Alert message"}
        open={openSnack}
        autoHideDuration={6000}
        onClose={e => setOpenSnack(false)}
      >
        <Alert severity="error">
          Could not list files in project!
        </Alert>
      </Snackbar>
    </Dialog>
  );
};
